import { SetWebSocketDataAction, WebSocketActionTypesKeys } from '@store/action-types/websocket-actions-types'

// eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
export function setWebSocketData(data: any): SetWebSocketDataAction {
  return { type: WebSocketActionTypesKeys.SET_WEBSOCKET_DATA, payload: { message: data.type, payload: data.payload } }
}
